import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../common/components";
import '../../leads/lead-filter/lead-filter-options/./filter-options-text.scss';

const FormNameFilter: any = (
  props: any
) => {
  const { formName, handleFormNameChange, isFormNameEnabled, formNameError } = props
  useEffect(() => {
    if (!isFormNameEnabled) {
      handleFormNameChange({ target: { value: "", name: "formName" } } as any, "formName");
    }
  }, [isFormNameEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          formName: formName,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="formName"
            placeholder="Enter Form Name"
            optional={false}
            disabled={false}
            value={formName}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleFormNameChange(e, "formName")
            }
          />
          {formNameError && <div className="error-text">{formNameError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default FormNameFilter;